export function getDateRangeError(fromDate: string, toDate: string): string | undefined {
  if (!fromDate || !toDate) return undefined;
  if (fromDate > toDate) return 'From date cannot be later than To date';
  return undefined;
}
